var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2070_1780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33331 5.83333C3.33331 5.61232 3.42111 5.40036 3.57739 5.24408C3.73367 5.0878 3.94563 5 4.16665 5H5.83331C6.05433 5 6.26629 5.0878 6.42257 5.24408C6.57885 5.40036 6.66665 5.61232 6.66665 5.83333V8.33333C6.66665 8.55435 6.57885 8.76631 6.42257 8.92259C6.26629 9.07887 6.05433 9.16667 5.83331 9.16667H4.16665C3.94563 9.16667 3.73367 9.07887 3.57739 8.92259C3.42111 8.76631 3.33331 8.55435 3.33331 8.33333V5.83333Z",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 3.33337V5.00004",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 9.16663V16.6666",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33331 12.5C8.33331 12.2789 8.42111 12.067 8.57739 11.9107C8.73367 11.7544 8.94563 11.6666 9.16665 11.6666H10.8333C11.0543 11.6666 11.2663 11.7544 11.4226 11.9107C11.5788 12.067 11.6666 12.2789 11.6666 12.5V15C11.6666 15.221 11.5788 15.4329 11.4226 15.5892C11.2663 15.7455 11.0543 15.8333 10.8333 15.8333H9.16665C8.94563 15.8333 8.73367 15.7455 8.57739 15.5892C8.42111 15.4329 8.33331 15.221 8.33331 15V12.5Z",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 3.33337V11.6667",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 15.8334V16.6667",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 4.99996C13.3333 4.77895 13.4211 4.56698 13.5774 4.4107C13.7337 4.25442 13.9456 4.16663 14.1666 4.16663H15.8333C16.0543 4.16663 16.2663 4.25442 16.4226 4.4107C16.5788 4.56698 16.6666 4.77895 16.6666 4.99996V8.33329C16.6666 8.55431 16.5788 8.76627 16.4226 8.92255C16.2663 9.07883 16.0543 9.16663 15.8333 9.16663H14.1666C13.9456 9.16663 13.7337 9.07883 13.5774 8.92255C13.4211 8.76627 13.3333 8.55431 13.3333 8.33329V4.99996Z",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 3.33337V4.16671",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 9.16663V16.6666",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2070_1780"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.5a49f723d6d5979aa0fa1da3c10fe48b.svg";
export { ForwardRef as ReactComponent };